module.exports = __webpack_public_path__ + "static/media/star.06b73149.svg";